import { useEffect, useLayoutEffect, useState } from 'react';

import * as T from '../../../../components/Typography';
import { PlayButton } from '../../../../components/Button';
import { useLocation } from 'react-router-dom';
import StepFooterButtons from '../StepFooterButtons';

import * as S from './style';
import * as SharedStyles from '../shared/style';
import { BasicInput } from 'components/Inputs';
import { getOperatorSymbol } from 'helpers';
import TryAgainModal from 'components/Modal/TryAgainModal';
import { getMediaUrl } from '../../../../helpers';
import { audio } from '../../../../constants';
import { useGeneralState } from '../../../../context/general-state';

const Formulae = ({
  data: {
    textAudio,
    textAudioUrl,
    inputsPerRow,
    formulaType,
    rows = [],
    answers: _answers = [],
  } = {},
  handleNext,
  stuckAtReview,
  disabled,
  preview,
}) => {
  const [enableNext, setEnableNext] = useState(false);
  const [showTryAgain, setShowTryAgain] = useState(false);
  const [answers, setAnswers] = useState(
    _answers?.map((a) => ({ ...a, value: '' }))
  );
  const [showRotateMsg, setShowRotateMsg] = useState(false);
  const { state: generalState } = useGeneralState();

  const location = useLocation();
  useEffect(() => {
    setEnableNext(false);
  }, [location]);

  useLayoutEffect(() => {
    const ro = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setShowRotateMsg(
          inputsPerRow > 4 &&
            entry.contentRect.height > entry.contentRect.width &&
            entry.contentRect.width < 790
        );
      }
    });
    ro.observe(document.body);
    return () => ro.disconnect();
  }, [inputsPerRow]);

  useEffect(() => {
    if (answers?.length) {
      const allInputsHaveAnswers = answers?.every((a) => !!answers[a.id].value);
      setEnableNext(allInputsHaveAnswers);
    }
  }, [answers, _answers]);

  const onAnswerChange = ({ value, id }) => {
    const newAnswers = answers?.map((e) => {
      if (e.id !== id) return e;
      return {
        ...e,
        value,
      };
    });
    setAnswers(newAnswers);
  };

  const onNext = () => {
    const allCorrect = answers?.every(
      (a) => answers[a.id].value === _answers[a.id].value
    );

    if (allCorrect || stuckAtReview) {
      handleNext();
    } else {
      setShowTryAgain(true);
    }
  };

  return (
    <>
      <S.Wrapper display={showRotateMsg ? 'none' : 'flex'}>
        <S.ContentWrapper>
          {!!textAudio && (
            <S.TextAudioWrapper mt="2" mb="4">
              {textAudioUrl ? (
                <>
                  <PlayButton
                    audioUrl={textAudioUrl}
                    width="56px"
                    height="56px"
                    iconProps={{ width: '32px', height: '32px' }}
                    fallbackText={textAudio}
                  />
                  <T.P ml={4} weight="regular" size="med">
                    {textAudio}
                  </T.P>
                </>
              ) : (
                <T.P weight="regular" size="regular">
                  {textAudio}
                </T.P>
              )}
            </S.TextAudioWrapper>
          )}

          <S.RowsWrapper jc="space-between">
            {rows?.map((rowInputs, rowIndex) => (
              <S.RowWrapper key={rowIndex} inputsPerRow={inputsPerRow}>
                {rowIndex === rows.length - 1 && (
                  <S.FormulaeBox id="formulaBox">
                    <T.P size="large">{getOperatorSymbol(formulaType)}</T.P>
                  </S.FormulaeBox>
                )}
                <S.RowInputsWrapper
                  inputsPerRow={inputsPerRow}
                  addLeftPlaceholder={rowIndex !== rows.length - 1}
                >
                  {rowInputs?.map((input) => {
                    const id = input.id;
                    const value = input.value;

                    return (
                      <S.FormulaeBox key={id} id="formulaBox">
                        <T.P size="large">{value}</T.P>
                      </S.FormulaeBox>
                    );
                  })}
                </S.RowInputsWrapper>
              </S.RowWrapper>
            ))}
          </S.RowsWrapper>

          <SharedStyles.Divider />

          <S.RowWrapper inputsPerRow={inputsPerRow} mr={5}>
            <S.RowInputsWrapper inputsPerRow={inputsPerRow} addLeftPlaceholder>
              {answers?.map((answer, answerIndex) => {
                const id = answer?.id;

                return (
                  <div key={id} id="#formulaBox">
                    <BasicInput
                      key={id}
                      placeholder=""
                      value={answer?.value}
                      handleChange={(value) => {
                        onAnswerChange({
                          value,
                          id,
                        });
                      }}
                      hideErrorMsg
                      borderColor="#3D6FB6"
                      borderWidth="2px"
                    />
                  </div>
                );
              })}
            </S.RowInputsWrapper>
          </S.RowWrapper>
        </S.ContentWrapper>

        <StepFooterButtons
          stuckAtReview={stuckAtReview}
          handleNext={onNext}
          preview={preview}
          disabled={disabled}
          enableNext={enableNext}
        />

        <TryAgainModal
          isModalVisible={showTryAgain}
          setIsModalVisible={setShowTryAgain}
        />
      </S.Wrapper>
      <S.RotateWrapper display={showRotateMsg ? 'flex' : 'none'}>
        <PlayButton
          audioUrl={getMediaUrl(
            audio.pleaseRotateYourScreen,
            true,
            generalState?.preferredVoice
          )}
          iconProps={{ width: '32px', height: '32px' }}
          padding="12px"
          mt={5}
          mx="auto"
          mxM="0"
          fallbackText={
            'Please rotate your screen to landscape for this exercise'
          }
        >
          Please rotate your screen to landscape for this exercise
        </PlayButton>
      </S.RotateWrapper>
    </>
  );
};

export default Formulae;
